import { React, useState } from "react";
import { ArrowDropDown, Clear } from "@mui/icons-material";
import * as clientActions from "redux/actions/clientActions";
import { Autocomplete, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as userActions from "redux/actions/userActions";

const SelectClient = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const clients = useSelector((state) => state.currentUser.clients) ?? [];
  const selectedClient = useSelector((state) => state.clients.selectedClient);
  const { setSelectedClient } = clientActions;

  const uniqueClientsByName = () => {
    return [
      ...new Map(clients.map((item) => [item.clientName, item])).values(),
    ];
  };

  const handleClientChange = (client) => {
    if (client) {
      dispatch(setSelectedClient(client));
      dispatch(userActions.resetSelectedNotificationComment());
      localStorage.setItem("selectedClient", JSON.stringify(client));
      redirectToListPage();      
    }
  };

  const redirectToListPage = () => {
    //redirect to list page if currently on details page
    const path = history.location.pathname;

    const isDetailsPage = path.indexOf("details") > -1 ||
      path.indexOf("timeline") > -1 ||
      path.indexOf("comments") > -1 ||
      path.indexOf("documents") > -1 ||
      path.indexOf("templates") > -1 ||
      path.indexOf("associated") > -1 ||
      path.indexOf("audit") > -1;

    // const isDetailsPage = /details/.test(path);

    if (isDetailsPage) {
      const splitPath = path.split("/");
      history.push(`/${splitPath[1]}`);
    }
  };

  return (
    <div style={{ marginRight: "20px", marginTop: "4px", marginBottom: "4px" }}>
      <Autocomplete
        size="small"
        sx={{
          minWidth: 170,
          "& .MuiOutlinedInput-root": {
            borderRadius: "6px",
            "& fieldset": { borderColor: "#ced5d8" },
            "&:hover fieldset": { borderColor: "#ced5d8" },
          },
        }}
        options={uniqueClientsByName()}
        getOptionLabel={(option) => option.clientName ?? ""}
        isOptionEqualToValue={(option, value) => option.clientId === value?.clientId}
        value={selectedClient ?? {}}
        onChange={(e, v) => handleClientChange(v)}
        popupIcon={<ArrowDropDown sx={{ color: "#56656b" }} />}
        clearIcon={<Clear sx={{ color: "#56656b" }} fontSize="12px" />}
        ListboxProps={{
          sx: {
            '& .MuiAutocomplete-option': {
              fontSize: 14,
            }
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            sx={{
              input: {
                color: "#01151d",
                fontSize: 14,
              },
            }}
          />
        )}
      />
    </div>
  );
};

export default SelectClient;
